import { dummyMRData } from "../components/MR/MRComponents/dummyData";

// Utility function to fetch maintenance requests from Zoho Creator
export const fetchMRData = async (forceRefresh = false) => {
  const conn_name = "crmwidgetconnection";
  const apiUrl =
    "https://www.zohoapis.com/creator/v2.1/data/sst1source/source-erp/report/Management_Review_Report";

  const req_data = {
    parameters: {},
    headers: {
      "Content-Type": "application/json",
    },
    method: "GET",
    url: apiUrl,
    param_type: 1,
  };

  try {
    console.log("Fetching fresh MR data from API...");
    const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, req_data);

    console.log("MR API Response:", response);

    if (
      !response ||
      response.code !== "SUCCESS" ||
      !response.details ||
      !response.details.statusMessage ||
      !response.details.statusMessage.data
    ) {
      console.error("Invalid MR response structure:", response);
      return [];
    }

    const maintenanceRequests = response.details.statusMessage.data.map(
      (mr) => ({
        id: mr.ID,
        name: mr.Name || "Unnamed MR",
        status: mr.Status || "",
        // Include any other fields you might need
        ...mr,
      })
    );

    return maintenanceRequests;
  } catch (error) {
    console.error("Error fetching maintenance requests:", error);
    return [];
  }
};

// Function to filter maintenance requests by search term
export const filterMRBySearchTerm = (maintenanceRequests, searchTerm) => {
  if (
    !searchTerm ||
    typeof searchTerm !== "string" ||
    !maintenanceRequests ||
    maintenanceRequests.length === 0
  ) {
    return maintenanceRequests;
  }

  const normalizedSearchTerm = searchTerm.toLowerCase().trim();

  // First prioritize MRs that start with the search term
  const startsWithMatches = maintenanceRequests.filter(
    (mr) => mr.name && mr.name.toLowerCase().startsWith(normalizedSearchTerm)
  );

  // Then include MRs that contain the search term elsewhere
  const containsMatches = maintenanceRequests.filter(
    (mr) =>
      mr.name &&
      mr.name.toLowerCase().includes(normalizedSearchTerm) &&
      !(mr.name && mr.name.toLowerCase().startsWith(normalizedSearchTerm))
  );

  // Combine both results: first the "starts with" matches, then the "contains" matches
  return [...startsWithMatches, ...containsMatches];
};

// Function to invalidate cache (no-op, since cache is removed)
export const invalidateMRCache = () => {
  // No cache to invalidate
  console.log("invalidateMRCache called, but caching is disabled.");
};
